import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import { MGSiteButton } from 'mgUiKit';
import DepositToolsListTable from '../Table/DepositToolsList';
import IconButton from 'material-ui/IconButton';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'DepositToolsListComponent';
import { ClassName} from "mgToolsKit";

var styles = AppSettings.styles;

class DepositTools extends React.Component {
    constructor(props, context) {
        super(props);
        this.openPage = this.openPage.bind(this);
    }
    
    openPage(){
        // Se la userbox non è aperta apro la tab pannello per poi
        // mostrare l'elenco dei sistemi di ricarica
        if(!this.context.userboxOpened){
            this.context.handleTab("panel");
        }
        var body = <DepositToolsListTable />;
        this.context.handleSetPage("Ricarica conto gioco", body,true);
    }

    render(){
        var className = [];
        className.push(this.props.classNameButton);
        className.push("mg-user-widget--ricarica");
        if(this.props.typeButton == "button"){
            return(               
                <MGSiteButton
                    title="Ricarica"
                    class={ClassName(className)}
                    label="Ricarica"
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={false}
                    actionFunc={this.openPage}
                />
            )
        }
        if(this.props.typeButton == "link"){
            return(
                <a href="#" title="Ricarica" className={this.props.classNameButton} onClick={this.openPage}><span>Ricarica<i></i></span></a>
            )
        }
        if(this.props.typeButton == "icon"){
            return(
                // <IconButton onClick={this.openPage}
                //     iconClassName="fa-mg fa-mg-euro"
                //     iconStyle={styles.topIconStyle}
                // />
                <i className="fa-mg fa-mg-euro" onClick={this.openPage}></i>
            )
        }

        return "";
    }
}

DepositTools.displayName = componentName;

// PropTypes validation
DepositTools.propTypes = {
    classNameButton: PropTypes.string,
    typeButton: PropTypes.string
};

// default props
DepositTools.defaultProps = {
    classNameButton: "",
    typeButton: "button"
};

DepositTools.contextTypes = {
    handleSetPage: PropTypes.func,
    userboxOpened: PropTypes.bool,
    handleTab: PropTypes.func
}
export default  DepositTools;